import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: 'cutstr',
})
export class CutstrPipe implements PipeTransform {
    constructor() {}

    transform(str: string, len: number): any {
        if (!str) {
            return '';
        }
        let strLength = 0;
        let strLen = 0;
        // tslint:disable-next-line:no-construct
        let strCut = new String();
        strLen = str.length;
        for (let i = 0; i < strLen; i++) {
            const a = str.charAt(i);
            strLength++;
            if (escape(a).length > 4) {
                // 中文字符的长度经编码之后大于4
                strLength++;
            }
            strCut = strCut.concat(a);
            if (strLength === len && i + 1 === strLen) {
                return strCut;
            } else if (strLength > len) {
                strCut = strCut.substring(0, strCut.length - 1).concat('...');
                return strCut;
            }
        }
        // 如果给定字符串小于指定长度，则返回源字符串；
        if (strLength <= len) {
            return str;
        }
    }
}
